import * as api from '../api';

export const SET_MAGAZINE_ISSUES = 'SET_MAGAZINE_ISSUES';
export const SET_MAGAZINE_CURRENT_ISSUE = 'SET_MAGAZINE_CURRENT_ISSUE';

export const getMagazineIssues = () => (dispatch) =>
  api.getMagazineIssues()
    .then(issues => {
      dispatch(setMagazineIssues(issues))
      return issues;
    });

export const setMagazineIssues = (issues) => {
  return {
    type: SET_MAGAZINE_ISSUES,
    issues
  }
}

export const getMagazineCurrentIssue = () => (dispatch) =>
  api.getMagazineCurrentIssue()
    .then(currentIssue => {
      dispatch(setMagazineCurrentIssue(currentIssue))
      return currentIssue;
    });

export const setMagazineCurrentIssue = (currentIssue) => {
  return {
    type: SET_MAGAZINE_CURRENT_ISSUE,
    currentIssue
  }
}


// WEBPACK FOOTER //
// ./src/actions/magazine.js